/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../constants/ServiceConstants';
import utils from '../../../../common/utils';

export default class GetLLMLogsService extends BaseService {
  constructor() {
    super(constants.GET_LLM_LOGS, 'getLLMLogsStatus');
  }

  async handleEvent(eventName, event) {
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);
    const { requestId } = payload;

    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient('aiadminstackb').get(`/llmlogs/${requestId}`, { headers: enhancedHeaders });
    }
    return this.getClient('aiadmin').get(`/llmlogs/${requestId}`, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    if (data && data.success) {
      Framework.getStoreRegistry().getStore('graphTesterModel').setLLMLogs(data);
      Framework.getEventManager().publish(constants.GET_LLM_LOGS_SUCCESS, { data });
    } else {
      const notification = {
        open: true,
        type: 'error',
        message: 'Error fetching LLM logs'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      Framework.getStoreRegistry().getStore('graphTesterModel').setLLMLogsError('Logs not found');
      Framework.getEventManager().publish(constants.GET_LLM_LOGS_ERROR);
    }
  }

  handleError(error) {
    const { response } = error;
    if (response) {
      const { status } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
    }
    Framework.getStoreRegistry().getStore('graphTesterModel').setLLMLogsError('Failed to fetch LLM logs');
    Framework.getEventManager().publish(constants.GET_LLM_LOGS_ERROR);
  }
}
